
$(document).ready(function (e) {
  // 썸네일 미리보기
  $('#product_thumbnail').change(function(){
    let reader = new FileReader();
    reader.onload = (e) => {
      $('#preview-image-before-upload').attr('src', e.target.result);
    }
    reader.readAsDataURL(this.files[0]);
  });

});

/***********************************************************************
 * function Name : add_row
 * description : 할인조건 및 사용기한 설정 (횟수, 할인금액, 사용기한 등록  add row )
 *
 ***********************************************************************/
function add_row() {
  var table = document.getElementById("prd_infos_table")
  var row = table.insertRow(1);
  row.innerHTML = "<td class='text-left  text-truncate' data-column='no' colspan='1'><input class='form-control' name='count[]' autocomplete='off' inputmode='numeric' style='text-align: right;'></td><td class='text-left  text-truncate ' data-column='' colspan='1'><div> <div class='form-group mb-0'> <div> <input class='form-control' name='discount_price[]'  title='할인금액' autocomplete='off' inputmode='numeric' style='text-align: right;'> </div> </div> </div></td> <td> <input class='form-control' name='due_date[]' title='사용기한' type='number'></td>";
}


function changeProductType() {
  var itemIdSelect = document.getElementById("product_type");
  var itemId = itemIdSelect.options[itemIdSelect.selectedIndex].value;

  const target_opt_duet       = document.getElementById('option_price_duet');
  const target_opt_duet_unit  = document.getElementById('option_unit_price_duet');
  const target_opt_group      = document.getElementById('option_price_group');
  const target_opt_group_unit = document.getElementById('option_unit_price_group');
  if(itemId === "1") {
    //PT 상품인 경우에만 옵션 가격 설정 disable 해제
    target_opt_duet.disabled = false;
    target_opt_duet_unit.disabled = false;
    target_opt_group.disabled = false;
    target_opt_group_unit.disabled = false;
  } else {
    target_opt_duet.disabled   = true;
    target_opt_duet_unit.disabled   = true;
    target_opt_group.disabled   = true;
    target_opt_group_unit.disabled   = true;
  }

}

/***********************************************************************
 * function Name : inputNumberFormat
 * description : 숫자입력 자동 콤마
 *
 ***********************************************************************/
function inputNumberFormat(obj) {
  obj.value = comma(uncomma(obj.value));
}

function comma(str) {
  str = String(str);
  return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
}

function uncomma(str) {
  str = String(str);
  return str.replace(/[^\d]+/g, '');
}

function submit() {
  $('#create_form').submit();
}
